import React, { useRef, useState } from 'react';
import { translate, t } from 'react-switch-lang';
import { ExternalLink } from './Link';
import { events, logAmpEvent } from '../utils/Amplitude';
import { setScreenReaderAlert } from '../utils/Accessibility';
import InfoCopyField from './InfoCopyField';
import { formatCurrency } from '../utils/Helpers';
import ReplaceTextWithElement from './ReplaceTextWithElement';

const formatAmount = (amt) => {
  const formattedCurrency = formatCurrency(amt);
  return formattedCurrency.replace(/\s/g, '').replace(/\$/g, '');
};

function EtransferCodes({
  recipientName,
  recipientEmail,
  amount,
  securityQuestion,
  securityAnswer,
}) {
  const [copied, setCopied] = useState('');
  const timer = useRef(null);
  function onCopyClick(value, label) {
    clearTimeout(timer.current);
    navigator.clipboard.writeText(value);
    logAmpEvent(events.USER_CLICKED_ETRANSFER_CODE_COPY, { Field: label });
    setScreenReaderAlert(t('ScreenReaderAlert_CopiedDetails'));
    setCopied(label);
    timer.current = setTimeout(() => setCopied(null), 2000);
  }

  return (
    <>
      <div className="eTransferCard">
        {t('Instructions_InteraceTransfer_HelpCentre_Prompt')}
        {' '}
        <ExternalLink
          text={t('Instructions_InteraceTransfer_HelpCentre_LinkText')}
          aria-label={t('Instructions_InteraceTransfer_HelpCentre_LinkDescription')}
          href={t('Link_Maple_InteraceTransfer_HelpCentre')}
          ampEvent={events.USER_OPENED_INTERAC_E_TRANSFER_HELPCENTRE_LINK}
        />
      </div>

      <div className="eTransferCard">
        <div className="mb-4">
          <h3 className="cardTitle">
            <ReplaceTextWithElement
              text={t('Instructions_InteraceTransfer_V2_FindInterac_Title')}
              replaceWith={
                <i>Interac</i>
            }
              replaceKey="Interac"
            />
          </h3>
          <ol>
            <li>
              {t('Instructions_InteraceTransfer_V2_FindInterac_Step1')}
              <br />
              <ExternalLink
                className="specialWarningLink"
                text={t('SpecialBanksWarningTitle')}
                aria-label={t('SpecialBanksWarning_LinkDescription')}
                href={t('Link_Maple_Help_InteraceTransferKohoWiseAdvisory')}
                ampEvent={events.USER_OPENED_SPECIAL_BANKS_HELPCENTRE_LINK}
              />
            </li>
            <li>
              {t('Instructions_InteraceTransfer_V2_FindInterac_Step2_Part1')}
              {' '}
              <span className="eTransferBoldText">
                <ReplaceTextWithElement
                  text={t('Instructions_InteraceTransfer_V2_FindInterac_Step2_Part2')}
                  replaceWith={
                    <i>Interac</i>
                  }
                  replaceKey="Interac"
                />
              </span>
            </li>
          </ol>
        </div>
        <p className="eTransferDisclaimer">
          {t('Instructions_InteraceTransfer_V2_FindInterac_Disclaimer')}
        </p>
      </div>

      <div className="eTransferCard">
        <div className="mb-4">
          <h3 className="cardTitle">
            {t('Instructions_InteraceTransfer_V2_CreateRecipient_Title')}
          </h3>
          <ol>
            <li>
              {t('Instructions_InteraceTransfer_V2_CreateRecipient_Step1')}
              <br />
              <ExternalLink
                className="specialWarningLink"
                text={t('BillPayHelpWarningTitle')}
                aria-label={t('BillPayHelpWarning_LinkDescription')}
                href={t('Link_Maple_Help_CantFindUsInTheList')}
                ampEvent={events.USER_OPENED_BILL_PAY_HELPCENTRE_LINK}
              />
            </li>
          </ol>
        </div>
        <InfoCopyField label={t('TransferDetailsRecipientName')} value={recipientName} copied={copied} onCopyClick={onCopyClick} />
        <InfoCopyField preventBrowserTranslate label={t('TransferDetailsRecipientEmail')} value={recipientEmail} copied={copied} onCopyClick={onCopyClick} />
      </div>

      <div className="eTransferCard">
        <div className="mb-4">
          <h3 className="cardTitle">
            <ReplaceTextWithElement
              text={t('Instructions_InteraceTransfer_V2_SendTransfer_Title')}
              replaceWith={
                <i>Interac</i>
              }
              replaceKey="Interac"
            />
          </h3>
          <ol>
            <li>
              {t('Instructions_InteraceTransfer_V2_SendTransfer_Step1')}
            </li>
            <li>
              <ReplaceTextWithElement
                text={t('Instructions_InteraceTransfer_V2_SendTransfer_Step2')}
                replaceWith={
                  <i>Interac</i>
                  }
                replaceKey="Interac"
              />
              <br />
              <ExternalLink
                className="specialWarningLink"
                text={t('Instructions_InteraceTransfer_CreateOwnQA')}
                aria-label={t('CreateOwnQA_LinkDescription')}
                href={t('Link_Maple_Help_CreateOwnQA')}
                ampEvent={events.USER_OPENED_CREATE_OWN_QA_HELPCENTRE_LINK}
              />
            </li>
          </ol>
        </div>
        <InfoCopyField label={t('TransferDetailsAmount')} value={formatAmount(amount)} copied={copied} onCopyClick={onCopyClick} />
        <InfoCopyField preventBrowserTranslate label={t('TransferDetailsQuestion')} value={securityQuestion} copied={copied} onCopyClick={onCopyClick} />
        <InfoCopyField preventBrowserTranslate label={t('TransferDetailsAnswer')} value={securityAnswer} copied={copied} onCopyClick={onCopyClick} />
      </div>
    </>
  );
}

export default translate(EtransferCodes);
